import { ApolloError } from '@apollo/client';
import { ERROR_CODES } from '@shinetools/errors';

import locales from './locales';

export const getLocalizedError = (error: unknown): string => {
  if (error instanceof ApolloError) {
    const graphqlErrorMessage = error.graphQLErrors[0]?.extensions.code;
    if (
      graphqlErrorMessage === ERROR_CODES.COMPANY_INVITATION_QUOTA_LIMIT_REACHED
    ) {
      return locales.errors[
        ERROR_CODES.COMPANY_INVITATION_QUOTA_LIMIT_REACHED
      ] as string;
    } else if (graphqlErrorMessage === ERROR_CODES.EMAIL_ALREADY_EXISTS) {
      return locales.errors[ERROR_CODES.EMAIL_ALREADY_EXISTS] as string;
    }
  }
  return locales.errors.invitationError;
};
